<template>
  <zm-drawer :title="title" :width="drawerWidth" :visible="visible" size="large" @cancel="open(false)" :footer="false">
    <div slot="drawerBody">
      <a-form :form="form">
        <div class="title">产品信息</div>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item label="产品线" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                placeholder="请选择生产线"
                disabled
                v-decorator="['productLineName', { rules: [{ required: true, message: '请选择生产线！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item label="产品类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                placeholder="请选择产品类型"
                disabled
                v-decorator="['productTypeName', { rules: [{ required: true, message: '请选择产品类型！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item label="迭代产品" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-switch
                v-decorator="['iterateProductState', { valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"
                disabled
              ></a-switch>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item label="关联产品" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                :allowClear="true"
                placeholder="请选择关联产品"
                disabled
                v-decorator="[
                  'relateProductName',
                  { rules: [{ required: form.getFieldValue('iterateProductState'), message: '请选择关联产品！' }] },
                ]"
              >
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item label="产品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                placeholder="请输入产品名称"
                disabled
                v-decorator="['productName', { rules: [{ required: true, message: '请输入产品名称！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item label="产品概述" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
              <zm-editor :height="76" v-model="productOverview" disabled></zm-editor>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- 此处循环 -->
        <div class="title">功能模块</div>
        <div v-for="(item, i) in model.productModules" :key="i">
          <a-row>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="功能名称">
                <a-input
                  :allowClear="true"
                  placeholder="请输入功能名称"
                  disabled
                  v-decorator="[
                    `name[${item}]`,
                    {
                      initialValue: item ? item.name : undefined,
                      rules: [{ required: true, message: '请输入功能名称' }],
                    },
                  ]"
                >
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item :labelCol="{xs: { span: 24 },sm: { span: 6 }}" :wrapperCol="{xs: { span: 24 },sm: { span: 13 }}" label="成本价">
                <a-input
                  :allowClear="true"
                  placeholder="请输入成本价"
                  disabled
                  v-decorator="[
                    `costPrice[${item}]`,
                    {
                      initialValue: item ? item.costPrice : undefined,
                      rules: [{ required: false, message: '请输入成本价' }],
                    },
                  ]"
                >
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="功能描述" :labelCol="labelCol2" :wrapperCol="wrapperCol2">
                <zm-editor :height="76" v-model="item.description" disabled></zm-editor>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>
  </zm-drawer>
</template>
<script>


export default {
  mounted() {
    console.log('已经加载')
  },
  props: {
    associatedSelect: { type: Array },
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth() {
      const width = window.innerWidth - 600
      return width
    },
  },
  data() {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      form: this.$form.createForm(this, { name: 'product' }),
      visible: false,
      defaultModel: {},
      productOverview: '',
      model: {
        id: '',
        productType: '',
        productModules: [{}],
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      colSpan: 12,
      show: false,
      editorStatus: '',
      editorHelp: '',
    }
  },
  methods: {
    // 设置类型
    setType(type) {
      this.type = type
    },
    // 设置标题
    setTitle(title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      this.model = Object.assign({}, model)
      this.productOverview = model.productOverview
      console.log('productOverview:', this.model.productOverview)
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      this.show = flag
      this.visible = flag
      if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
        if (flag) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              productLineName: this.model.productLineName,
              productTypeName: this.model.productTypeName,
              iterateProductState: this.model.iterateProductState,
              relateProductName: this.model.relateProductName,
              productName: this.model.productName,
            })
          })
          this.productOverview = this.model.productOverview
        }
      }
    },
  },
}
</script>

<style scoped>
.title {
  font-weight: bold;
  margin-bottom: 10px;
}
.title::before {
  display: inline-block;
  width: 4px;
  height: 12px;
  background: #1791ff;
  content: '';
  margin-right: 7px;
}
.title_1 {
  color: #b3b3b3;
  margin-right: 12px;
}
</style>
